const toggleModal = (target) => $(target).toggleClass('active');

$('.modal * [tabindex]').attr('tabindex', "-1");
// set timeout
setTimeout(() => {
  $('.modal * [tabindex]').attr('tabindex', "-1");
}, 1500);

$(document).on('click keydown', '[data-modal]', function (event) {
  if (event.type === 'keydown' && event.key !== 'Enter') {
    return;
  }

  $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  $('.modal.active').removeClass('active');
  const target = $(this).data('modal');
  const unique = $(this).attr('data-modal-unique');

  toggleModal(`#modal--${target}${unique || ''}`);

  if ($(`#modal--${target}${unique || ''}`).hasClass('active')) {
    const video = $(`#modal--${target}${unique || ''}`).find('video');
    if (video.length) {
      const bigPlayButton = video.next('.able-big-play-button');
      bigPlayButton.focus();
    }
  }

  $('body * [tabindex]').attr('tabindex', "-1");
  $('.modal.active * [tabindex]').attr('tabindex', "0");

  $('html').toggleClass('no-scroll');
});

$('.modal__close').on('click keyup', function (event) {
  if (event.type === 'click' || (event.type === 'keyup' && (event.keyCode === 13 || event.which === 13))) {
    const modal = $(this).parent().parent();
    $('html').removeClass('no-scroll');
    toggleModal(modal);

    $('body * [tabindex]').attr('tabindex', "0");
    $('.modal * [tabindex]').attr('tabindex', "-1");
    $('[data-modal]').attr('aria-expanded', 'false');
    
    const video = $(modal).find('video');
    if (video.length) {
      video[0].pause();
    }
  }
});

$(document).keydown(function (e) {
  if (e.keyCode === 27) {
    const activeModal = $('.modal.active');
    if (activeModal.length) {
      $('html').removeClass('no-scroll');
      toggleModal(activeModal);

      $('body * [tabindex]').attr('tabindex', "0");
      $('.modal * [tabindex]').attr('tabindex', "-1");
      $('[data-modal]').attr('aria-expanded', 'false');

      const video = $(activeModal).find('video');
      if (video.length) {
        video[0].pause();
      }
    }
  }
});
